import { gold } from '~/scopes/campaign/data/metals/gold'

import translations from './environmental.translations'
import type { Journey } from './types'

const t = translations

/**
 * Gold, open pit to shop counter. Coordinates are invented and the pins all carry the
 * impact's own icon; see `.claude/rules/guided-mining.md`.
 */
export const environmentalJourney: Journey = {
  impact: 'environmental',
  label: t.label,
  metal: gold,
  stops: [
    {
      slug: 'intro',
      label: t.introLabel,
      title: t.introTitle,
      body: t.introBody,
      bodyAfter: t.introBodyTwo,
      cta: t.introCta,
      location: {
        coordinates: [137.11, -4.06],
        zoom: 7,
      },
    },
    {
      slug: 'extraction',
      label: t.extractionLabel,
      title: t.extractionTitle,
      place: t.extractionPlace,
      body: t.extractionBody,
      citations: [1, 2],
      cta: t.extractionCta,
      location: {
        // The Grasberg pit, which is what the copy names, not Tembagapura town.
        coordinates: [137.11, -4.06],
        zoom: 9,
        pin: true,
      },
    },
    {
      // (Superseded: this position held `refining`, the one beat whose copy named no
      // place and which therefore stood unpinned over the pit. The V2 document gives
      // it a mine of its own, so it is a second extraction stop and a new slug — an
      // id follows its beat, and reusing the old one would hand it another stop's
      // translation.)
      slug: 'extraction-2',
      label: t.extractionPoboyaLabel,
      title: t.extractionPoboyaTitle,
      place: t.extractionPoboyaPlace,
      body: t.extractionPoboyaBody,
      citations: [3],
      cta: t.extractionPoboyaCta,
      location: {
        coordinates: [119.93, -0.87],
        zoom: 9,
        pin: true,
      },
    },
    {
      // Keeps `-swiss` from when gold had two refining stops: the suffix is spare
      // now, but the slug is this beat's identity and its translations follow it.
      slug: 'refining',
      label: t.refiningSwissLabel,
      title: t.refiningSwissTitle,
      place: t.refiningSwissPlace,
      body: t.refiningSwissBody,
      citations: [4],
      cta: t.refiningSwissCta,
      location: {
        coordinates: [8.98, 45.87],
        zoom: 9,
        pin: true,
      },
    },
    {
      slug: 'manufacture',
      label: t.manufactureLabel,
      title: t.manufactureTitle,
      place: t.manufacturePlace,
      body: t.manufactureBody,
      citations: [5],
      cta: t.manufactureCta,
      location: {
        // Guangzhou, not the province centroid, which lands in the mountains.
        coordinates: [113.26, 23.13],
        zoom: 9,
        pin: true,
      },
    },
    {
      // The last stop, so its CTA finishes into the metal's extended reader.
      slug: 'sale',
      label: t.saleLabel,
      title: t.saleTitle,
      place: t.salePlace,
      body: t.saleBody,
      cta: t.saleCta,
      location: {
        // Fifth Avenue — now gold's alone, since `human` ends in Paris.
        coordinates: [-73.9733, 40.7636],
        zoom: 9,
        pin: true,
      },
    },
  ],
}
